module.exports = __webpack_public_path__ + "img/account-icon-active.24747d1b.svg";